import React from 'react';
import Hero from '../../components/hero/Hero';
import WhyUs from '../../components/why-us/WhyUs';
import Solutions from '../../components/solutions/Solutions';
import Services from '../../components/services/Services';
import FeaturedProject from '../../components/featured-project/FeaturedProject';
import TechStack from '../../components/tech-stack/TechStack';
import Partnerships from '../../components/partnerships/Partnerships';
import AnnouncementBanner from '../../components/AnnouncementBanner';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <AnnouncementBanner />
      <WhyUs />
      <Solutions />
      <Services />
      {/* <FeaturedProject /> */}
      <TechStack />
      <Partnerships />
    </main>
  );
};

export default HomePage;